<!--
 * @Author: linrui
 * @Date: 2021-12-21 17:52:35
 * @LastEditors: linrui
 * @LastEditTime: 2022-01-08 16:52:37
 * @FilePath: /wechat-frontend/zmtx/src/views/doctor/recordTable.vue
-->
<template>
    <div class="record-table-wrap">
        <van-tabs class="record-tabl-tans" v-model="active" background="#EDEDED" sticky>
            <van-tab title="文件下载">
                <div class="download-box">
                    <div class="record-lists">
                        <div v-for="(item,index) in lists" :key="index" class="record-item">
                            <div class="item-img" @click="showImage(item.src,true)">
                                <van-image :src="item.src"></van-image>
                            </div>
                            <div class="item-info">
                                <div class="item-info-title">{{ item.title }}</div>
                                <div class="item-info-desc">{{ item.desc }}</div>
                                <div class="btn">
                                    <van-row>
                                        <!-- <van-col span="12">
                                            <van-button class="back" @click="showImage(item.src)">预览</van-button>
                                        </van-col> -->
                                        <van-col span="12">
                                            <van-button class="up" @click="showImage(item.src,true)">保存</van-button>                                        
                                        </van-col>
                                    </van-row>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>
            <van-tab title="上传">
                <div class="upload-box">
                    <!-- <p class="title">备案表&备忘录</p> -->
                    <p class="desc">&nbsp;&nbsp;&nbsp;您已通过援助项目的培训考试，现需要您上传备案文件图片，备案表和备忘录均需上传（备案文件可通过左侧下载），请在下方上传</p>
                    <div class="img-box">
                        <van-row>
                            <van-col span="8" v-for="(item,index) in images" :key="index" class="uploaded-img-box" @click="showImage(item.src,false)">
                                <van-image width="80" fit="contain" height="80"  class="uploaded-images" :src="item.src">
                                    <i class="van-icon van-icon-clear van-uploader__preview-delete" @click.stop="deleteTempImage(item,index)"></i>
                                    <!-- <van-icon color="#E30A0A" size="24px" name="close" /> -->
                                </van-image>
                            </van-col>
                            <van-col span="8" @click="chooseImg" v-if="num > 0">
                                <div class="van-uploader__wrapper">
                                    <div class="van-uploader__upload">
                                        <i class="van-icon van-icon-photograph van-uploader__upload-icon"></i>
                                        <div class="van-uploader__input"></div>
                                    </div>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                    <p class="tips">《医生理解备忘录》、《项目医生备案表》填写完整后，电子备案文件请通过上方进行上传，项目办将在线审核，审核通过后为您制作“项目专用章“，原件请您邮寄到以下地址：北京市100024信箱59号分箱 中国初级卫生保健基金会“择美同行-患者援助项目办公室”（只接受EMS特快专递），项目联系电话：010-56592455，感谢您的配合与支持！</p>
                    <div class="btn">
                        <van-button class="up" :disabled="submitBtnDisabled" @click="submitRecordTable">提交</van-button>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
        <van-image-preview v-model="showImageRreview" :images="previewImage">
            <template v-slot:cover v-if="showPreviewImageCover">请长按图片保存</template>
        </van-image-preview>
    </div>
</template>

<script>
import doctor_record_table from '@/assets/doctor_record_table.png'
import record_table from '@/assets/record_table.png'
import {mapState} from 'vuex'
import {
    DownloadImage,
    SubmitDocRecordAttach,
    RemoveDocRecordAttach,
    GetDocRecordAttach,
    GetDocRecordExample
} from '../../api/api'
import { Dialog} from 'vant'

export default {
    data() {
        return {
            active:0,
            submitBtnDisabled:false,//禁用提交按钮
            showImageRreview:false,//是否预览图片
            showPreviewImageCover:false,//是否展示“请长按图片保存提示”
            lists:[{
                src:doctor_record_table,
                title:'医生理解备忘录',
                desc:'《医生理解备忘录》您下载打印后填写完整并加盖医务科或科室章。',
            },{
                src:record_table,
                title:'项目医生备案表',
                desc:'《项目医生备案表》您下载打印后填写完整，并书写多种笔体，方便项目办核对您的签字。',
            }],
            previewImage:[],//当前预览的图片
            images:[]
            // images:[
            //     {src:'http://ecasev2-api.papv2.sungotech.com/upload/image/202112/03/4fdac9eb572912b83694eb04ad0f2ce2.jpg'},
            //     {src:'http://ecasev2-api.papv2.sungotech.com/upload/image/202112/03/4fdac9eb572912b83694eb04ad0f2ce2.jpg'}
            // ]
        }
    },

    computed: {
        ...mapState({
            doctorInfo: state => state.doctor.doctorInfo,
        }),
        num() {
            let n = 0
                n = 9 - this.images.length
            return n
        }
    },

    created() {
        console.log(this.baseUrl,'this.baseUrl');
        GetDocRecordAttach({
            params:{id:this.doctorInfo.id}
        }).then( res => {
            if(res.data) {
                res.data.forEach( item => {
                    this.images.push({
                        id:item.id,
                        src:`${this.baseUrl}${item.image}`
                    })
                })
            }
            console.log(res,'获取备案表历史数据');
        })
        GetDocRecordExample({
            params:{id:this.doctorInfo.id}
        }).then( res => {
            console.log(res,'获取备案实例图片')
            if(res.data) {
                if(res.data.memo) {
                    this.lists[0].src = `${this.baseUrl}${res.data.memo}`
                }
                if(res.data.example_image) {
                    this.lists[1].src = `${this.baseUrl}${res.data.example_image}`
                }
            }
        }).catch( err => {
            this.$toast(err.response.data.message)
        })
        if (this.doctorInfo.record_status=='电子审核不通过') {
            this.active = 1
        }
    },

    methods:{

        //预览图片
        showImage(src,flag) {
            let tempImg = []
            tempImg.push(src)
            this.showImageRreview = true
            this.previewImage = tempImg
            this.showPreviewImageCover = flag
        },

        //保存图片
        saveImage() {
            this.$toast({
                duration:6000,
                message:'预览后请长按图片并保存下载'
            })
        },

        //调取相机接口
        chooseImg() {
            this.wx.chooseImage({
                count: this.num, // 默认9
                sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                success: async res => {
                        try {
                            for (let index = 0; index < res.localIds.length; index++) {
                                const serverId = res.localIds[index];
                                await this.uploadImage(serverId);
                            }
                        } catch (err) {
                            Toast(err.response.data.message);
                        }
                    },
                fail: function () {
                    this.$toast("选图失败")
                }
            })
        },

        //上传图片的接口
        async uploadImage(serverId) {
            return new Promise( (resolve,reject) => {
                this.wx.uploadImage({
                    localId: serverId, // 需要上传的图片的本地ID，由chooseImage接口获得
                    isShowProgressTips: 1, // 默认为1，显示进度提示
                    success:  res => {
                        console.log(res,"上传图片");
                        var serverId = res.serverId // 返回图片的服务器端ID
                        this.$toast.loading({
                            duration: 0, // 持续展示 this.$toast
                            forbidClick: true
                        })
                        DownloadImage({params: {serverId}}).then( res => {
                            console.log((res,'downloadImage图片'))
                            this.images.push({
                                serverId: serverId,
                                src:`${this.baseUrl}${res.data}`
                            })
                            this.$toast.clear()
                            resolve()
                        }).catch( err => {
                            console.log(err)
                            this.$toast.clear()
                            this.$toast(err.response.data.message)
                            reject(err)
                        })
                    }
                })
            })
        },

        //删除暂存的图片
        deleteTempImage(item,index) {
            Dialog.confirm({
                message: '确定删除？'
            }).then(() => {
                if(item.id) {
                    RemoveDocRecordAttach({
                        id:item.id
                    }).then( () => {
                        this.images.splice(index,1)
                        this.$toast('删除图片成功')
                    }).catch( err => {
                        this.$toast(err.response.data.message)
                    })
                } else {
                    RemoveDocRecordAttach({
                        src:this.images[index].src.split(this.baseUrl)[1]
                    }).then( () => {
                        this.images.splice(index,1)
                        this.$toast('删除图片成功')
                    }).catch( err => {
                        this.$toast(err.response.data.message)
                    })
                }
            })
        },

        //提交备案表
        submitRecordTable() {
            if(this.images.length == 0) {
                this.$toast('请上传图片')
                return
            }
            this.submitBtnDisabled = true
            this.$toast.loading({
                duration:0,
                forbidClick:true
            })
            // let historyImages = []
            // historyImages = this.images.filter(item => item.id)
            // if(historyImages.length == 9) {
            //     this.$toast('请先更新图片，再提交')
            //     this.submitBtnDisabled = false
            //     return
            // }
            let tempImgs = []
            tempImgs = this.images.filter(item => !item.id).map( item => {
                return {
                    src:item.src.split(this.baseUrl)[1]
                }
            })
            console.log(tempImgs,'tempImgs');
            if(tempImgs.length == 0) {
                this.$toast('请先更新图片，再提交')
                this.submitBtnDisabled = false
                return
            }
            SubmitDocRecordAttach({
                doctor_id:this.doctorInfo.id,
                checkItems:tempImgs
            }).then( () => {
                this.$router.replace({
                    name:'DoctorMsg',
                    query:{
                        value:'备案提交'
                    }
                })
                this.submitBtnDisabled = false
                this.$toast.clear()
            }).catch( err => {
                this.submitBtnDisabled = false
                this.$toast.clear()
                this.$toast(err.response.data.message)
            })
        }
    }
}
</script>
<style lang="less">
    .record-table-wrap {
        height: 100vh;
        background-color: #ECEDEC;
        .download-box {
            .record-lists {
                .record-item {
                    display: flex;
                    justify-content: space-between;
                    box-sizing: border-box;
                    background-color: #fff;
                    margin-bottom: 5px;
                    padding: 40px 10px 16px 24px;
                    .item-img {
                        height: 159px;
                        margin-right: 14px;
                        .van-image {
                            width: 100%;
                            height: 100%;
                            img {
                                width: 100px;
                            }
                        }
                    }
                    .item-info {
                        .item-info-title {
                            margin-bottom: 12px;
                            font-size: 16px;
                            color: #101010;
                        }
                        .item-info-desc {
                            font-size: 14px;
                            color: #101010;
                            opacity: .8;
                        }
                        .btn {
                            .van-button {
                                height: 36px;
                            }
                            .back {
                                border-color: @theme-color;
                                color: @theme-color;
                                border-radius: 10px;
                            }
                            .up {
                                background-color: @theme-color;
                                border-color: @theme-color;
                                color: #fff;
                                border-radius: 10px;                            
                            }
                        }
                    }
                }
            }
        }
        .upload-box {
            padding: 30px 16px 10px;
            background-color: #fff;
            .title {
                padding: 0 16px;
                margin-bottom: 12px;
                font-size: 20px;
                color: #101010;
            }
            .img-box {
                padding: 0 16px;
                margin: 34px 0;
                .uploaded-img-box {
                    margin-bottom: 7px;
                    .uploaded-images {
                        background-color: #f7f8fa;
                        border-radius: 8px;
                    }
                }
            }
            .desc {
                margin-bottom: 12px;
                text-indent: 36px;
                font-size: 18px;
                // color: #78797B;
                color: #333;
            }
            .tips {
                padding-bottom: 30px;
                text-indent: 36px;
                text-align: justify;
                word-break: break-all;
                font-size: 14px;
                color: #9B9B9C;
            }
            .btn {
                margin-top: 0;
                padding: 0 60px;
                border-top: none;
                .up {
                    width: 100%;
                    min-width: none;
                    height: 38px;
                    background-color: @theme-color;
                    font-size: 16px;
                    border-radius: 10px;
                    .van-button__content {
                        .van-button__text {
                            margin-left: 24px;
                            text-align: justify;
                            letter-spacing: 24px;
                        }
                    }
                }
            }
        }
        .van-tabs {
            .van-tabs__wrap {
                height: 48px;
                .van-tabs__nav {
                    .van-tab {
                        color: #050605;
                        font-size: 16px;
                    }
                    .van-tab--active {
                        background-color: @theme-color;
                        color: #fff;
                    }
                    .van-tabs__line {
                        height: 0;
                    }
                }
            }
        }
        .van-image {
            background: #f6f6f6;
            .van-uploader__preview-delete {
                background: transparent; color: #aaa; font-size: 16px; height: 16px; width: 16px; border-radius: 16px; top: -6px; right: -6px; box-shadow: 0 0 0 1px #fff;
            }
        }
        // .van-uploader__preview-delete {
        //     background-color: transparent;
        //     font-size: 24px; 
        //     top: -9px; 
        //     right: -9px;
        // }
        .van-image-preview__cover {
            top: initial;
            left: 50%;
            bottom: 44px;
            transform: translateX(-50%);
            padding: 3px 10px;
            border-radius:5px ;
            background-color: #F3FCFD ;
            color: @theme-color;
            font-size: 16px;
            text-shadow: initial;
        }
    }
</style>